// load script dynamically
export function loadScript(src, type) {
  return new Promise((resolve, reject) => {
    if (document.querySelector(`script.loaded[src="${src}"]:not(.error)`)) {
      resolve();
      return;
    }
    const script = document.createElement('script');
    script.async = true;
		if (type) {
			script.type = type;
		}
    script.onload = (e) => {
      script.classList.add('loaded');
      resolve();
    };
    script.onerror = (e) => {
      script.classList.add('error');
      reject(new Error());
    };
    script.src = src;
    document.body.appendChild(script);
  });
}

export default loadScript;
